"use client"

import {
  type RefObject,
  createContext,
  createRef,
  useContext,
  useRef,
} from "react"

type Scroller = RefObject<HTMLElement | null>

export const ScrollerContext = createContext<Scroller>(createRef())

interface Props {
  scroller: Scroller
  children: React.ReactNode
}

export function ScrollerProvider(props: Props) {
  return (
    <ScrollerContext.Provider value={props.scroller}>
      {props.children}
    </ScrollerContext.Provider>
  )
}

export const useScroller = () => {
  const scroller = useContext(ScrollerContext)

  return scroller
}
